let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("86uh3")).then(() => parcelRequire('3jAQn'));